export default {
  driver_performance_events_assingDriver_driver: "Driver",
  driver_performance_events_assingDriver_selectDriver: "Select Driver",
  driver_performance_events_assingDriver_title: "Update Assigned Driver",

  driver_performance_events_assingDriver_success: "Driver updated successfully",
  driver_performance_events_assingDriver_error: "Error updating driver",
};